import {details} from './imports/utilities/details';
import oembed from './imports/utilities/oembed';
import gdprManager from './imports/gdpr-manager';

document.addEventListener("DOMContentLoaded", function() {
    details.toggle();
    gdprManager();
    oembed();
});
